// extracted by mini-css-extract-plugin
export default {"botao":"customStep_botao__93hZG","container":"customStep_container__brykd","step":"customStep_step__fQSze"};